module.exports = __webpack_public_path__ + "static/media/image-4.11d32b56.jpg";